import React from 'react';

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, onSearchChange }) => {
  return (
    /*
      A toolbar joined to the top of the table, exactly like /past-submissions
      and /dashboard: white chrome block with the search control on the trailing
      edge. It used to float on the page background above a detached table,
      which read as two unrelated elements.
    */
    <div className="flex px-4 py-3 bg-white border rounded-t-lg border-neutral-200 sm:justify-end">
      <div className="relative w-full sm:w-80">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg
            className="w-5 h-5 text-neutral-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          type="text"
          placeholder="Search artists..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full py-2 pl-10 pr-3 leading-5 placeholder-neutral-400 bg-white border border-neutral-300 rounded-lg focus:outline-none focus:border-primary-500"
        />
      </div>
    </div>
  );
};

export default SearchBar;